import React from 'react';
import { styled } from '@mui/material/styles';
import { keyframes, useTheme } from '@emotion/react';
import { Box } from '@mui/material';
import LogoAcademy from "assets/images/LogoAcademy.png";


const scale = keyframes`
  0%{
    transform: scale(1);
  }
  50%{
    transform: scale(1.1);
  }
  100%{
    transform: scale(1);
  }
`;

const AnimatedLogo = styled('img')({
  width: 100,
  height: 100,
  margin: 'auto',
  animation: `${scale} 2s infinite ease`,
});

function Loading() {
  const theme = useTheme();
  return (
    <Box
      sx={{
        position: 'absolute',
        left: 0,
        top: 0,
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'canter',
        overflow: 'hidden',
        background: theme.palette.background.main,
      }}
    >
      <AnimatedLogo src={LogoAcademy} alt="On Acamedy" />
    </Box>
  );
}

export default Loading;
